import React from "react";
import { Loader, AlertCircle, RefreshCw, BarChart3 } from "lucide-react";
import { ActionButton } from "../ui/ActionButton";

export const ActivityLoadingState = ({ message = "Loading activity data..." }) => (
  <div className="text-center py-12">
    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl mb-6 shadow-lg">
      <Loader className="w-10 h-10 text-white animate-spin" />
    </div>
    <h3 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      {message}
    </h3>
    <p className="text-lg text-slate-600">Please wait while we fetch your activity data</p>
  </div>
);

export const ActivityErrorState = ({ message, onRetry }) => (
  <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
    <div className="bg-gradient-to-r from-red-500 to-pink-600 p-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
          <AlertCircle className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-white">Error Loading Activities</h2>
          <p className="text-white/80 text-sm">Failed to fetch activity data</p>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
    </div>
    <div className="p-8 text-center">
      <p className="text-slate-600 mb-6 text-lg">{message}</p>
      {onRetry && (
        <ActionButton 
          onClick={onRetry} 
          variant="primary"
          className="transform hover:scale-105 transition-transform duration-200"
        >
          <RefreshCw className="w-5 h-5 mr-2" />
          Retry Loading Activities
        </ActionButton>
      )}
    </div>
  </div>
);